import React from 'react';
import { NpsCampaignDto } from '@area-restrita/api-client/model/npsCampaignDto';
import { NpsCampaignResultsSummaryQueryResponse } from '@area-restrita/api-client/model/npsCampaignResultsSummaryQueryResponse';

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Badge } from '@/components/ui/badge';
import {
  NPS_STATUS_LABELS,
  formatApiNumber,
  formatApiPercent,
  formatDateTime,
  formatInteger,
} from '@/modules/nps/utils';

import NpsResultsDistribution from './NpsResultsDistribution';
import NpsResultsMetricCard from './NpsResultsMetricCard';

interface IProps {
  campaign: NpsCampaignDto;
  summary: NpsCampaignResultsSummaryQueryResponse;
}

const NpsResultsSummary: React.FC<IProps> = ({ campaign, summary }) => {
  const isOpen = campaign.status === 'open';

  return (
    <div className="flex flex-col gap-4">
      <Alert>
        <AlertTitle>
          {isOpen ? 'Resultados parciais' : 'Resultados finais'}
        </AlertTitle>
        <AlertDescription>
          {isOpen
            ? 'Os resultados podem mudar enquanto a campanha estiver aberta.'
            : 'A campanha foi encerrada e os resultados estão consolidados.'}
        </AlertDescription>
      </Alert>

      <div className="flex flex-wrap items-center gap-2 text-sm">
        <Badge variant={campaign.status === 'closed' ? 'outline' : 'secondary'}>
          {NPS_STATUS_LABELS[campaign.status]}
        </Badge>
        <span className="text-muted-foreground">
          Período da campanha: {formatDateTime(campaign.startAt)} a{' '}
          {formatDateTime(campaign.endAt)}
        </span>
      </div>

      <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-5">
        <NpsResultsMetricCard
          title="NPS"
          value={formatApiNumber(summary.nps)}
          primary
        />
        <NpsResultsMetricCard
          title="Nota média"
          value={formatApiNumber(summary.averageScore)}
        />
        <NpsResultsMetricCard
          title="Respostas recebidas"
          value={formatInteger(summary.responseCount)}
        />
        <NpsResultsMetricCard
          title="Pessoas elegíveis"
          value={formatInteger(summary.eligibleUsersCount)}
        />
        <NpsResultsMetricCard
          title="Taxa de participação"
          value={formatApiPercent(summary.participationRate)}
        />
      </div>

      <NpsResultsDistribution distribution={summary.distribution} />
    </div>
  );
};

export default NpsResultsSummary;
